// extracted by mini-css-extract-plugin
module.exports = {"FavoriteButton":"FavoriteButton_FavoriteButton__mcucB","favorited":"FavoriteButton_favorited__vXWi2"};